// Redux Reducers
import {
  SET_MESSAGE_IFRAME,
  SET_FULLWIDTH_IFRAME,
  SET_STATE_VIDEO_IFRAME,
  SET_MINIMIZE_PLAYLIST_IFRAME,
  SET_TREE_VIDEOS_IFRAME,
  SET_VIDEO_IFRAME,
  SET_MODE_IFRAME,
  SET_SAMPLER,
} from "../types";

const initialState = {
  IMessage: null,
  IFullWidth: false,
  IStateVideo: -1,
  IMinimizePlaylist: false,
  ITreeVideos: [],
  IVideo: null,
  IMode: null,
  ISampler: true
};

function iframeReducer(state = initialState, action) {

  if (action.type === SET_MESSAGE_IFRAME) {
    return { ...state, IMessage: action.payload }
  }

  if (action.type === SET_FULLWIDTH_IFRAME) {
    return { ...state, IFullWidth: action.payload }
  }

  if (action.type === SET_STATE_VIDEO_IFRAME) {
    return { ...state, IStateVideo: action.payload }
  }

  if (action.type === SET_MINIMIZE_PLAYLIST_IFRAME) {
    return { ...state, IMinimizePlaylist: action.payload }
  }

  if (action.type === SET_TREE_VIDEOS_IFRAME) {
    return { ...state, ITreeVideos: action.payload }
  }

  if (action.type === SET_VIDEO_IFRAME) {
    return { ...state, IVideo: action.payload }
  }

  if (action.type === SET_MODE_IFRAME) {
    return { ...state, IMode: action.payload }
  }

  if (action.type === SET_SAMPLER) {
    return { ...state, ISampler: action.payload }
  }

  return state;
};

export default iframeReducer;
